import { Promise } from 'rsvp';
import Service, { inject as service } from '@ember/service';
import { APP_CACHE__COMMON_TIMEOUTS } from "../app-cache";

/**
 * Service for company group related API calls.
 */
export default Service.extend({
  api: service(),

  /**
   * Load all company groups from the server.
   *
   * @return {Ember.RSVP.Promise}
   */
  loadAllCompanyGroups() {
    return this.api.request(`company-groups/`);
  },
});
